import memoize from 'memoize-one';
import { PureComponent } from 'react';

import Latex from './Latex';

// const regex = /(?:(?<!\\)\$)?([^\$]+)(?:(?<!\\)\$)?/g;

export default class LatexString extends PureComponent {
  parseString = memoize(string => {
    if (!string.match(/\$.+\$/)) return [{ content: string, type: 'text' }];
    const result = [];
    let curSnippet = '';
    let latexCtx = false;
    for (let i = 0; i < string.length; i++) {
      if (string[i] === '$') {
        if (string[i - 1] === '\\') {
          curSnippet = curSnippet.substring(0, curSnippet.length - 1) + '$';
        } else {
          if (latexCtx) {
            result.push({ content: curSnippet, type: 'latex' });
            curSnippet = '';
            latexCtx = false;
          } else {
            if (string.substring(i + 1).match(/[^\\]\$/)) {
              // has upcoming closing $
              result.push({ content: curSnippet, type: 'text' });
              curSnippet = '';
              latexCtx = true;
            } else {
              curSnippet += '$';
            }
          }
        }
      } else {
        curSnippet += string[i];
      }
    }
    result.push({ content: curSnippet, type: 'text' });
    return result.filter(s => s.content.length);
  });

  render() {
    const { children } = this.props;

    if (!children) return null;
    return this.parseString(children).map(({ content, type }, i) =>
      type === 'text' ? content : <Latex key={i}>{content}</Latex>,
    );
  }
}

LatexString.containsLatex = function (string) {
  return !string.match(/\$.+\$/);
};
